import {Box, styled} from '@mui/material';

export const StyledFooterContainer = styled(Box)`
	margin: auto 0px 32px;
	padding-top: 40px;

	${({theme}) => theme.breakpoints.up('md')} {
		margin: auto 24px 0px;
		& footer {
			margin-inline: 0px;
		}
	}
`;
